import { FC } from "react";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Icon } from "Components/UI";
import {
  BtnContainer,
  Container,
  Content,
  Title,
} from "./styles";

interface IDisciplineActivities {
  visible: boolean;
  active?: boolean;
  loading?: boolean;
  isDefault?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DisciplineActivities: FC<IDisciplineActivities> = ({
  visible,
  active,
  loading,
  isDefault,
  onConfirm,
  onCancel,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onCancel();
  }

  return (
    <Modal
      visible={visible}
      width={450}
      footerButtons={null}
    >
      <Container>
        <Title>
          <span className="textTitle">
            {`${active ? 'Desativar' : 'Ativar'} validação da vinculação de disciplinas nas atividades?`}
          </span>
        </Title>

        <Content>
          <span className="contentText">
            {active
              ? 'Você tem certeza que deseja desativar a validação da vinculação de disciplinas nas atividades? Isso fará com que seja possível selecionar qualquer etapa na atividade, sem limitar elas com base nas disciplinas selecionadas.'
              : 'Você tem certeza que deseja ativar a validação da vinculação de disciplinas nas atividades? Isso irá limitar as etapas que poderão ser selecionadas na atividade, mostrando apenas as etapas que tenham as mesmas disciplinas vinculadas na atividade.'
            }
          </span>
          {!active && (
            <span className="warningBox">
              <Icon
                icon="alerta"
                customSize={16}
                className="alertIcon"
              />
              <span className="alertText">
                Essa ação pode ocasionar a invalidação de atividades que tenham etapas que não tem vínculo com as disciplinas da atividade.
              </span>
            </span>
          )}
        </Content>

        <BtnContainer>
          <Button type="text" className="cancelBtn" onClick={onCancel}>
            Cancelar
          </Button>
          {!isDefault && (
            <Button
              type="primary"
              className="deleteBtn"
              onClick={handleConfirm}
              primaryDanger={active}
            >
              {loading && (
                <Spin
                  indicator={
                    <LoadingOutlined
                      color="white"
                      style={{ fontSize: 12, color: 'white', marginRight: 6 }}
                    />
                  }
                />
              )}
              {active && (loading ? 'Desativando...' : 'Desativar')}
              {!active && (loading ? 'Ativando...' : 'Ativar')}
            </Button>
          )}
        </BtnContainer>
      </Container>
    </Modal>
  )
}

export default DisciplineActivities;
